import axios from '../axios';
// 车辆表列表
export const getBaseCarPage = data => {
    return axios({
        url: '/api/sys/getBaseCarPage',
        method: 'post',
        data
    })
};
// 车辆表列表保存
export const saveBaseCar = data => {
  return axios({
      url: '/api/sys/saveBaseCar',
      method: 'post',
      data
  })
};
// 车辆表列表修改
export const updateBaseCar = data => {
  return axios({
      url: '/api/sys/updateBaseCar',
      method: 'post',
      data
  })
};
// 车辆表列表删除
export const deleteBaseCars = data => {
  return axios({
      url: '/api/sys/deleteBaseCars',
      method: 'post',
      data
  })
};

// 车辆进出记录表列表
export const getBaseCarLogPage = data => {
  return axios({
      url: '/api/sys/getBaseCarLogPage',
      method: 'post',
      data
  })
};
// 辆进出记录保存
export const saveBaseCarLog = data => {
  return axios({
      url: '/api/sys/saveBaseCarLog',
      method: 'post',
      data
  })
};
// 辆进出记录修改
export const updateBaseCarLog = data => {
  return axios({
      url: '/api/sys/updateBaseCarLog',
      method: 'post',
      data
  })
};
// 辆进出记录删除
export const deleteBaseCarLogs = data => {
  return axios({
      url: '/api/sys/deleteBaseCarLogs',
      method: 'post',
      data
  })
};


// WEBPACK FOOTER //
// ./src/api/moudules/Car.js